import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Client, ClientDetails } from '../model/client';
import { Observable } from 'rxjs';
import { UtilitiesService } from './utilities.service';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private http: HttpClient, private utilities: UtilitiesService) { }

  private readonly baseUri = 'clients';

  public fetchAll(
    pageIndex: Number = 1,
    pageSize: Number,
    sortBy: string,
    order: string,
    columnSearch: string
  ): Observable<Client> {
    var id = this.utilities.clientId;
    const fdcidParam = id ? `&fdcid=${id}` : '';
    const url =
      `${this.baseUri}?page=${pageIndex}&limit=${pageSize}&sortBy=${sortBy}&order=${order}${columnSearch}` + fdcidParam;
    return this.http.get<Client>(url);
  }

  public getClientsGuard(
    pageIndex: Number = 1,
    pageSize: Number,
    sortBy: string,
    order: string,
    columnSearch: string,
    id: number
  ): Observable<Client> {
    ;
    const url =
      `${this.baseUri}?page=${pageIndex}&limit=${pageSize}&sortBy=${sortBy}&order=${order}${columnSearch}` + `&fdcid=${id}`;
    return this.http.get<Client>(url);
  }

  public fetchById(id: Number): Observable<ClientDetails> {
    const url = `${this.baseUri}/${id}`;
    return this.http.get<ClientDetails>(url);
  }

  public update(client: Client) {
    return this.http.patch(`${this.baseUri}/` + client['fdClientId'], client);
  }

  public updateClientViaForm(client: Client, fdclientId) {
    return this.http.patch(`${this.baseUri}/` + fdclientId, client);
  }

  public bulkUpdate(updateRequest) {
    return this.http.patch(`${this.baseUri}/bulk-update`, updateRequest);
  }

  public bulkDelete(deleteRequest) {
    return this.http.post(`${this.baseUri}/bulk-delete`, deleteRequest);
  }

  public import(csvFile) {
    return this.http.post(`${this.baseUri}/import`, csvFile);
  }

  public getPartnerClients() {
    return this.http.get(`${this.baseUri}/select`);
  }

  public getNotificationsSettings(fdClientId: number) {
    return this.http.get(`${this.baseUri}/notifications/${fdClientId}`);
  }

  public updateNotificationsSettings(fdClientId: number, payload) {
    return this.http.patch(`${this.baseUri}/notifications/${fdClientId}`, payload);
  }

  public updateEmailList(fdClientId: number, payload) {
    return this.http.patch(`${this.baseUri}/personal-info/${fdClientId}`, payload);
  }
}
